
/* injects from baggage-loader */

'use strict';

function runBlock($log, $rootScope, $timeout, $window, $location, $transitions, Parse, User, Alerts, ErrorHandler, cfpLoadingBar, DEFAULT_PAGE_TITLE) {
	'ngInject';

	// NOTE: TEMPALTE REPLACEMENT HANDLED BY WEBPACK, DON'T EDIT MANUALLY
	// Initialize parse with Application key only
	Parse.initialize('historic-funds');

	// NOTE: TEMPALTE REPLACEMENT HANDLED BY WEBPACK, DON'T EDIT MANUALLY
	// Set server URL
	Parse.serverURL = 'https://api.historicfunds.com/parse';

	// Create the main application state
	$rootScope.state = {
		transitions: {}
	};

	// State animation settings
	// Remove class name or set false to disable
	$rootScope.state_transitions = {
		main: false, // 'state-transition-slide',
		child: false
	};


	// Set UI Router error handler
	$transitions._router.stateService.defaultErrorHandler(function (error) {
		/* ignore routing errors */
		// $log.error(error);

		if (typeof error.detail !== 'undefined') {
			// $log.error('Error code:', error.detail.code);
			// $log.error('Error msg:', error.detail.message);

			// Pass it to the error handler
			ErrorHandler(error.detail);

		}

	});


	// =========================================
	// Global Transition Hooks
	// =========================================


	// Called when any state transition is about to begin
	$transitions.onStart({}, transition => {
		// Do stuff when the state transition begins

		// Show the loading bar
		cfpLoadingBar.start();

		// Listen for notifying transitions
		if (transition.options().notify !== false) {

			// Check if to state is set as previous in state data
			let previous = transition.from().data ? transition.from().data.previous : '';

			// Update state transition flags
			$rootScope.state.transitions.back = transition.to().name === previous;
			$rootScope.state.transitions.toHome = (transition.to().name === 'home');

		}

	});

	// Called when any state transition is entered
	$transitions.onEnter({}, transition => {

		// Clear any local alerts
		Alerts.clearLocal();

		// Un-hide the header incase it's been hidden by the previous state
		$rootScope.hideHeader = false;

		// Re-lock the header incase it's been modified by the previous state
		$rootScope.unlockHeader = false;

		// Un-hide the footer incase it's been hidden by the previous state
		$rootScope.hideFooter = false;

		// Redirect to login page if route is protected and no current user
		if (transition.to().protected === true && User.isUserLoggedIn() === false) {
			$location.path('/login');
			return transition.router.stateService.target('login');
		}

	});

	// Called when any state transition succeeds
	$transitions.onSuccess({}, transition => {

		// Remove the loading bar
		cfpLoadingBar.complete();

		// Always scroll to the top of the page on route change
		$window.scrollTo(0, 0);

		// Update document title
		$timeout(() => {
			if (typeof transition.to().title !== 'undefined' && transition.to().title.length > 0) {
				// Set document title for the current page
				$window.document.title = `${DEFAULT_PAGE_TITLE} | ${transition.to().title}`;
			} else {
				// Set the default page title
				$window.document.title = DEFAULT_PAGE_TITLE;
			}
		}, 250);

	});

	// Called when any state transition encounters an error
	$transitions.onError({}, (transition, state) => {
		// Handle transition errors

		// Remove the loading bar
		cfpLoadingBar.complete();

	});

		// Setup object prototypes
		let ProjectDocument = Parse.Object.extend('Project_Documents');
		[
			'name',
			'file',
			'type'
		].forEach(function (field) {
			Object.defineProperty(ProjectDocument.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});	

}

export default runBlock;


// WEBPACK FOOTER //
// ./src/app/index.run.js